// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import IdleVue from 'idle-vue'

// Components
import './components'

// Plugins
import './plugins'

// Sync router with store
import { sync } from 'vuex-router-sync'
import { abilitiesPlugin } from '@casl/vue'

// Application imports
import App from './App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'

import Default from './layouts/Default.vue'
import NoSidebar from './layouts/NoSidebar.vue'
import { getInfo } from '@/api/user.js'
import AsyncComputed from 'vue-async-computed'
// import VueJsonPretty from 'vue-json-pretty'


import '@/permission' // permission control
Vue.config.productionTip = false

const eventsHub = new Vue()
Vue.use(IdleVue, { eventEmitter: eventsHub, idleTime: 1000 * 60 * 30 })
Vue.use(abilitiesPlugin, store.getters.ability);
Vue.use(AsyncComputed);

Vue.component('default-layout', Default)
Vue.component('no-sidebar-layout', NoSidebar)
// Vue.component('vue-json-pretty', VueJsonPretty);

// Sync store with router
sync(store, router)

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
  onIdle () {
    router.push({ path: '/logout' })
  },
  onActive (a) {
    // console.log('reactivate')
    // console.log(router.path)
    getInfo()
  }
}).$mount('#app')
